function csrfMetaField() {
  return document.querySelector('[name=csrf-token]');
}

export function getCsrfToken() {
  return csrfMetaField().content;
}

export function pageHasCsrfToken() {
  return csrfMetaField() !== null;
}
